import { SET_CLIENT_MONITOR_CONFIG, SET_CLIENT_MONITOR_CONFIG_FORBIDDEN } from '../../actionTypes/clientMonitorConfig'

const initialState = {
	config: null,
	forbidden: false,
}

export function clientMonitorConfigReducer (state = initialState, action) {
	switch (action.type) {
		case SET_CLIENT_MONITOR_CONFIG:
			return {
				...state,
				config: action.value,
				forbidden: false,
			}
		case SET_CLIENT_MONITOR_CONFIG_FORBIDDEN:
			return {
				...state,
				forbidden: action.value,
			}
		default:
			return state
	}
}
